import type React from "react";
import type { CatalogItem, CatalogItemEditables } from "../../../common/CatalogItem";
import FullArticle from "../../Storyblok/FullArticle";
import "../../Storyblok/Storyblok.css";
import "./AppPreview.css";
import { catalogItemToArticlePreview } from "../../../common/utils/catalog.util";

type AppPreviewProps = {
    children: React.ReactNode;
};

function AppPreview(props: AppPreviewProps) {
    const { children } = props;
    return (
        <div className="app-preview storyblok">
            <div className="app-preview__content">{children}</div>

            <div className="app-preview__mobile-frame" />
        </div>
    );
}

export default {
    WoaArticle: (props: { catalogItem: CatalogItem | CatalogItemEditables }) => {
        const { catalogItem } = props;
        const articlePreview = catalogItemToArticlePreview(catalogItem);

        return (
            <AppPreview key={JSON.stringify(articlePreview)}>
                <FullArticle blok={articlePreview} />
            </AppPreview>
        );
    },
};
